import script from "./ProductDetailTableBulkOperations.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailTableBulkOperations.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailTableBulkOperations.vue?vue&type=style&index=0&id=4db46370&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db46370"]])

export default __exports__